<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card title="KEEP IN TOUCH WITH US" pace="6"> </base-info-card>

      <base-business-contact dense />
    </div>
  </v-theme-provider>
</template>

<script>
export default {
  name: "BaseBusinessInfo",

  props: { dark: Boolean },

  data: () => ({
    business: [
      {
        icon: "mdi-map-marker-outline",
        title: "Address",
        text:
          "Julibee Employment Pte Ltd. <br>Blk 703 Bedok Reservoir Road, <br> #01-3510,<br> Singapore 470703"
      },
      {
        icon: "mdi-cellphone",
        title: "Phone",
        text: "+65 9859 6645" < br > "+65 9784 9202"
      },
      {
        icon: "mdi-email",
        title: "Email",
        text: "julibeeemployment@gmail.com"
      }
    ]
  })
};
</script>
